import { useState, useEffect } from 'react';
import requestApi from 'utils/Request';

const useRegions = () => {
  const [regions, setRegions] = useState([]);
  const [isRegionsLoading, setIsRegionsLoading] = useState(false);

  useEffect(() => {
    const fetchRegions = async () => {
      setIsRegionsLoading(true);
      try {
        const data = await requestApi.get('/region');
        setRegions(
          data.data?.map((r) => ({
            id: r.regionId,
            label: r.regionName,
            currency: r.currency ?? 'EUR',
            currencySymbol: r.currencySymbol ?? '€',
            timezone: r.timezone,
            // RAT-1684: per-region default merchant-deduction settings, used to
            // pre-fill deduction toggles when creating a new merchant.
            defaultIncludePowerbankCost: r.defaultIncludePowerbankCost,
            defaultIncludeCustomerPurchases: r.defaultIncludeCustomerPurchases,
            defaultIncludeTransactionCost: r.defaultIncludeTransactionCost,
            defaultIncludeEInvoiceFee: r.defaultIncludeEInvoiceFee,
          })) || [],
        );
      } catch (_error) {
        // silently fail — region list will remain empty
      } finally {
        setIsRegionsLoading(false);
      }
    };

    fetchRegions();
  }, []);

  return { regions, isRegionsLoading };
};

export default useRegions;
